import { SwUpdate } from '@angular/service-worker';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject, BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/service-worker";
import * as i2 from "@angular/material/snack-bar";
export class SwUpdateService {
    constructor(swUpdate, snackBar) {
        this.swUpdate = swUpdate;
        this.snackBar = snackBar;
        this.updateAvailable$ = new BehaviorSubject(false);
        this.updateActivated$ = new Subject();
        this.updateAvailable = this.updateAvailable$.asObservable();
        this.updateActivated = this.updateActivated$.asObservable();
        this.initializeUpdateDetection();
    }
    initializeUpdateDetection() {
        if (!this.swUpdate.isEnabled) {
            console.log('🚫 Service Worker no está habilitado en este entorno');
            return;
        }
        // Detectar cuando hay una nueva versión disponible
        this.swUpdate.available.subscribe((event) => {
            console.log('🔄 Nueva versión detectada:', event);
            this.updateAvailable$.next(true);
            this.handleUpdateAvailable();
        });
        // Detectar cuando se ha activado una nueva versión
        this.swUpdate.activated.subscribe((event) => {
            console.log('✅ Nueva versión activada:', event);
            this.updateActivated$.next();
        });
        // Verificar actualizaciones periódicamente
        this.startPeriodicUpdateCheck();
    }
    handleUpdateAvailable() {
        // Actualización automática simple
        this.performAutomaticUpdate();
    }
    performAutomaticUpdate() {
        console.log('%c🔄 Actualizando automáticamente...', 'background-color: #4caf50; color: white; padding: 4px; border-radius: 3px;');
        this.swUpdate.activateUpdate()
            .then(() => {
            console.log('✅ Actualización activada, recargando página...');
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        })
            .catch((error) => {
            console.error('❌ Error al activar actualización:', error);
            // Fallback: recargar después de un error
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        });
    }
    showUpdateNotification() {
        const snackBarRef = this.snackBar.open('🆕 Nueva versión disponible', 'Actualizar', {
            duration: 10000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: ['update-snackbar']
        });
        snackBarRef.onAction().subscribe(() => {
            this.performAutomaticUpdate();
        });
    }
    startPeriodicUpdateCheck() {
        // Verificar actualizaciones cada 5 minutos
        setInterval(() => {
            if (this.swUpdate.isEnabled) {
                this.swUpdate.checkForUpdate().catch((error) => {
                    console.error('❌ Error en verificación periódica:', error);
                });
            }
        }, 300000); // 5 minutos
    }
    // Método público para forzar verificación de actualizaciones
    checkForUpdate() {
        if (!this.swUpdate.isEnabled) {
            return Promise.reject('Service Worker no está habilitado');
        }
        console.log('🔍 Verificando actualizaciones manualmente...');
        return this.swUpdate.checkForUpdate()
            .then(() => {
            console.log('✅ Verificación de actualizaciones completada');
        })
            .catch((error) => {
            console.error('❌ Error al verificar actualizaciones:', error);
            throw error;
        });
    }
    // Método para activar actualizaciones pendientes
    activateUpdate() {
        if (!this.swUpdate.isEnabled) {
            return Promise.reject('Service Worker no está habilitado');
        }
        return this.swUpdate.activateUpdate()
            .then(() => {
            console.log('🔄 Actualización activada, recargando página...');
            window.location.reload();
        });
    }
}
SwUpdateService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SwUpdateService_Factory() { return new SwUpdateService(i0.ɵɵinject(i1.SwUpdate), i0.ɵɵinject(i2.MatSnackBar)); }, token: SwUpdateService, providedIn: "root" });
